/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import CompanyRootElement from '../CompanyInformation/style';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import { DEFAULT_ACCORDION_SIZE } from '../../../constants/app-constants';
import AccordionList, { isItemAvailableInside } from '../../../common/accordionList';

const Accreditations = ({ profileDetails = {}, loading = false, scrollRef = {} }) => {
  const { accreditations } = profileDetails || {};
  const { t } = useTranslation();
  let isValidItems = false;
  if (accreditations) {
    isValidItems = Object.keys(accreditations).map((item) => isItemAvailableInside(item, accreditations)).includes(true);
  }
  return (
    // eslint-disable-next-line
    <CompanyRootElement ref={(el) => (scrollRef.current[5] = el)}>
      {isValidItems && (
        <Box className="page-container">
          <Typography variant="headline-medium" mb={2} component="h3">
            {t('Accreditations')}
          </Typography>
          <Typography variant="body-copy-medium" mb={7} className="sub-description">
            {t('Accreditation helps educate, measure, and recognize our partners and their consultants for investing in customer success practices and services delivery. Accreditation is earned by completing a knowledge check on the topic, delivering the service to a customer, and having a positive review on the service delivery.')}
          </Typography>
          <AccordionList
            dataWatLoc="accreditations"
            items={accreditations}
            loading={loading}
            size={DEFAULT_ACCORDION_SIZE}
            imgKey="badge_url"
            titleKey="name"
          />
        </Box>
      )}
    </CompanyRootElement>
  );
};

/* eslint react/require-default-props: off */
Accreditations.propTypes = {
  profileDetails: PropTypes.shape({}),
  loading: PropTypes.bool,
  scrollRef: PropTypes.shape({}),
};
export default ProfileContextConsumer(Accreditations);
